<template>
  <div>
    <p class="subheading">Uwierzytelnianie dwuskładnikowe</p>

    <p class="title">{{ enabled ? 'Włączone' : 'Wyłączone' }}</p>
  </div>
</template>

<script>
export default {
  props: {
    enabled: {
      type: Boolean,
      required: true
    }
  }
};
</script>
